export const strings = {
    login: {
        title: "Logga in",
        userID: "Användarnamn",
        password: "Lösenord"
    },
    signup: {
        title: "Registrera",
        userID: "Användarnamn",
        password: "Lösenord"
    },
    reset: {
        currentPassword: "Nuvarande Lösenord",
        newPassword: "Nytt Lösenord",
        confirmPassword: "Bekräfta Nytt Lösenord",
        update: "Uppdatera",
        longEnough: "Minst åtta tecken",
        containsUpper: "Minst en gemen",
        containsLower: "Minst en versal",
        containsNumber: "Minst en siffra",
        containsSymbol: "Minst ett specialtecken"
    },
    admin: {
        laundryTabTitle: "Antal tvättar ",
        balconyTabTitle: "Bokningar ",
        total: "Totalt: ",
        search: "Sök användare",
        export: "Exportera data",
        laundryTitle: "Tvättstugor",
        balconyTitle: "Gröningen"
    },
    payment: {
        firstInfoString: "Betala din bokning av Gröningen genom att scanna QR-koden nedan eller skriv in numret i swish-appen.",
        secondInfoString: 'Summan är 500kr, märk din betalning med ditt stugnummer likt: "tyluddenXXX".',
    },
    history: {
        title: "Historik",
        total: "Summa år ",
        unpaid: ", obetalda: "
    },
    home: {
        logout: "Logga ut",
        newBooking: "Ny bokning",
        myBookings: "Mina bokningar",
        chooseFacility: "Välj faciliet",
        laundry1: "Tvättstuga Övre",
        laundry2: "Tvättstuga Nedre",
        laundry3: "Tvättstuga 500",
        balcony: "Gröningen"
    },
    myBookings: {
        noBookings: "Inga aktiva bokningar",
        cancel: "Avboka",
        machine: "Maskin"
    },
    laundry: {
        laundryRoom: "Tvättstuga",
        machine1: "Tvättmaskin 1",
        machine2: "Tvättmaskin 2",
        bothMachines: "Tvättmaskin 1 och 2"

    },
    balcony: {
        balcony: "Gröningen"
    },
    dialogs: {
        limitTitle: "Bokningsfel",
        tooLateTitle: "Avbokningsfel",
        tooLate: "Det är för sent för att avboka den här tiden.",
        limit: "Du kan bara ha två kommande bokningar aktiva samtidigt.",
        fullyBooked: "Den här tiden är tyvärr fullbokad",
        alreadyBooked: "Den här tiden är tyvärr redan bokad av ",
        deleteConfirm: "Är du säker på att du vill avboka tiden?",
        confirmationTitle: "Sammanfattning",
        oneBookedBy: "Tvättmaskin 1 bokad av ",
        twoBookedBy: "Tvättmaskin 2 bokad av ",
        confirmation: "Boka",
        deleteTitle: "Avboka",
        bookPillar: "Boka Tvättmaskin ",
        cancelPillar: "Avboka Tvättmaskin ",
        updateTitle: "Uppdatera",
        updateAction: "Vill du ändra din bokning?",
        cancel: "Avbryt",
        ok: "OK"
    },
    burger: {
        start: "Boka",
        history: "Historik",
        pay: "Betala Bokning",
        pwdChange: "Byt Lösenord"
    }
}